import { Link } from "react-router-dom";
import Calculators from "./Calculators";
import Charts from "./Charts";
import { PublicNav, PublicTicker } from "./Home";

function Wrap({ children, testId }) {
  return (
    <div className="pub" data-testid={testId}>
      <PublicTicker />
      <PublicNav />
      <div className="main" style={{ margin: "0 auto" }}>
        <div className="note mb-4 flex justify-between items-center gap-3 flex-wrap"><span>Free tool — no account needed. Sign up to save results, link accounts and unlock the full platform.</span><Link to="/login?mode=register" className="btn sm" data-testid="tools-signup-btn">Start free</Link></div>
        {children}
      </div>
    </div>
  );
}

export function PublicCalculators() { return <Wrap testId="public-calculators"><Calculators /></Wrap>; }
export function PublicCharts() { return <Wrap testId="public-charts"><Charts /></Wrap>; }
